import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { FileStack } from "lucide-react";
import api from "@/lib/api";

export const PdfPageSelector = ({ praticaId, tipo, file }) => {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: ["pdf-pages", praticaId, tipo, file?.source_pdf_path],
    queryFn: async () => (await api.get(`/pratiche/${praticaId}/pdf-pages`, { params: { tipo } })).data,
    enabled: open,
    staleTime: Infinity,
  });
  const mut = useMutation({
    mutationFn: async (page) => (await api.post(`/pratiche/${praticaId}/pdf-page`, { tipo, page })).data,
    onSuccess: (f) => { qc.invalidateQueries({ queryKey: ["pratica", praticaId] }); toast.success(`Pagina ${f.pdf_page} impostata come planimetria`); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });

  if (!file?.pdf_page_count || file.pdf_page_count < 2) return null;
  return (
    <div className="mt-3">
      <button data-testid={`pdf-pages-toggle-${tipo}`} onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 text-xs text-amber-300 hover:text-amber-200">
        <FileStack className="h-3.5 w-3.5" /> PDF con {file.pdf_page_count} pagine · in uso pagina {file.pdf_page} — {open ? "chiudi" : "scegli pagina"}
      </button>
      {open && (
        <div data-testid={`pdf-pages-grid-${tipo}`} className="mt-2 grid grid-cols-4 gap-2">
          {isLoading && <p className="col-span-4 text-xs text-slate-500">Caricamento miniature…</p>}
          {data?.pages?.map((b64, i) => {
            const page = i + 1;
            const current = page === file.pdf_page;
            return (
              <button key={i} data-testid={`pdf-page-thumb-${tipo}-${page}`} disabled={mut.isPending || current} onClick={() => mut.mutate(page)}
                className={`relative rounded-md overflow-hidden border-2 ${current ? "border-cyan-400" : "border-slate-700 hover:border-cyan-500/60"} bg-white disabled:cursor-default`}>
                <img src={`data:image/png;base64,${b64}`} alt={`Pagina ${page}`} className="w-full h-20 object-contain" />
                <span className={`absolute bottom-0 inset-x-0 text-[10px] py-0.5 text-center ${current ? "bg-cyan-500 text-slate-900" : "bg-black/60 text-white"}`}>{current ? `Pag. ${page} · in uso` : `Pag. ${page}`}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
